import type { CartItem } from "./types";

export interface ShippingConfig {
  freeShippingThreshold: number;
  shippingFeeAmount: number;
}

const DEFAULT_SHIPPING_CONFIG: ShippingConfig = {
  freeShippingThreshold: 50,
  shippingFeeAmount: 6.90,
};

export function calculateCartTotals(cartItems: CartItem[], shippingConfig?: ShippingConfig) {
  const config = shippingConfig || DEFAULT_SHIPPING_CONFIG;
  const subtotal = cartItems.reduce((sum, item) => sum + item.product.price * item.quantity, 0);
  const taxRate = 0.20; // 20% TVA
  const taxAmount = subtotal * taxRate;
  const totalBeforeShipping = subtotal + taxAmount;

  // Shipping logic: free above threshold (based on TTC total)
  const shippingFee = cartItems.length > 0 && totalBeforeShipping < config.freeShippingThreshold
    ? config.shippingFeeAmount
    : 0;

  const total = totalBeforeShipping + shippingFee;
  const amountUntilFreeShipping = Math.max(0, config.freeShippingThreshold - totalBeforeShipping);

  return {
    subtotal: subtotal.toFixed(2),
    taxAmount: taxAmount.toFixed(2),
    totalBeforeShipping: totalBeforeShipping.toFixed(2),
    shippingFee: shippingFee.toFixed(2),
    total: total.toFixed(2),
    itemCount: cartItems.reduce((sum, item) => sum + item.quantity, 0),
    isFreeShipping: shippingFee === 0,
    amountUntilFreeShipping: amountUntilFreeShipping.toFixed(2),
    freeShippingThreshold: config.freeShippingThreshold,
  };
}
